export const baseNavigationLinks = [
  {
    label: 'Home',
    href: '/',
  },
  {
    label: 'Watch Now',
    href: '/browse',
  },
  {
    label: 'Trailer',
    href: '/watch/trailer',
  },
  {
    label: 'Pay it Forward',
    href: '/pay-it-forward',
  },
  {
    label: 'Merch',
    href: 'https://shop.christspiracy.com/',
    external: true,
  },
  {
    label: 'Spiritual Meal Planner',
    href: 'https://spiritualmealplanner.com',
    external: true,
  },
]

export const moreLinks = [
  {
    label: 'About',
    href: '/about',
  },
  {
    label: 'Sources',
    href: '/sources',
  },
  {
    label: 'Events',
    href: '/events',
  },
  {
    label: 'Contact',
    href: '/about#contact',
  },
  {
    label: 'Login',
    href: '/sign-in',
  },
  {
    label: 'Help',
    href: 'https://help.christspiracy.com',
    external: true,
  },
]

export const connectLinks = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/christspiracy/',
    external: true,
  },
  {
    label: 'TikTok',
    href: 'https://www.tiktok.com/@christspiracy',
    external: true,
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/christspiracy/',
    external: true,
  },
  {
    label: 'YouTube',
    href: 'https://www.youtube.com/@christspiracyfilm',
    external: true,
  },
  {
    label: 'X',
    href: 'https://x.com/christspiracy',
    external: true,
  },
  {
    label: 'Community',
    href: 'https://community.christspiracy.com/oauth2/callback',
    external: true,
  },
]
